import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrossedOutListPrice = ({
  listPrice,
  currencyCode,
  productApiName,
  showPerMonthPerSeat = false
}) => {
  if (showPerMonthPerSeat) {
    return /*#__PURE__*/_jsx(Text, {
      textDecoration: "line-through",
      typography: "heading-100",
      color: "text-core-subtle",
      paddingBlockStart: "400",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "priceComponents.pricePerMonthPerSeat",
        options: {
          price: /*#__PURE__*/_jsx(PriceDisplay, {
            price: listPrice,
            currencyCode: currencyCode,
            dataSelenium: `${productApiName}-list-price-strikethrough`
          })
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    textDecoration: "line-through",
    typography: "heading-100",
    color: "text-core-subtle",
    paddingBlockStart: "400",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonth",
      options: {
        price: /*#__PURE__*/_jsx(PriceDisplay, {
          price: listPrice,
          currencyCode: currencyCode,
          dataSelenium: `${productApiName}-list-price-strikethrough`
        })
      }
    })
  });
};